// extracted by mini-css-extract-plugin
export default {"indicator-positive":"Indicator_indicator-positive__UIQsc","indicator-negative":"Indicator_indicator-negative__E38fD","indicator-value":"Indicator_indicator-value__wzLJ6"};